var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUndo = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.48014 2.42384C5.79835 2.68901 5.84134 3.16193 5.57617 3.48014L4.10128 5.25H9.5C11.8472 5.25 13.75 7.15279 13.75 9.5C13.75 11.8472 11.8472 13.75 9.5 13.75H8C7.58579 13.75 7.25 13.4142 7.25 13C7.25 12.5858 7.58579 12.25 8 12.25H9.5C11.0188 12.25 12.25 11.0188 12.25 9.5C12.25 7.98122 11.0188 6.75 9.5 6.75H4.10128L5.57617 8.51987C5.84134 8.83807 5.79835 9.311 5.48014 9.57617C5.16193 9.84134 4.68901 9.79835 4.42383 9.48014L1.92383 6.48014C1.69206 6.20201 1.69206 5.798 1.92383 5.51987L4.42383 2.51987C4.68901 2.20166 5.16193 2.15866 5.48014 2.42384Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUndo);
export default ForwardRef;